import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  IParentTimetableResponse,
  IParentTimetableState,
} from '../../interface/parentTimetable.interface';
import { fetchParentTimetable } from '../action/parentTimetable.action';

const initialState: IParentTimetableState = {
  timetable: [],
  weekWindow: null,
  loading: false,
  error: null,
};

const parentTimetableSlice = createSlice({
  name: 'parentTimetable',
  initialState,
  reducers: {
    // The page dispatches this on mount and whenever the guardian switches
    // child, so one child's slots never flash on another child's page.
    resetParentTimetableState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchParentTimetable.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchParentTimetable.fulfilled,
        (state, action: PayloadAction<IParentTimetableResponse>) => {
          state.loading = false;
          state.timetable = action.payload.data.timetable || [];
          state.weekWindow = action.payload.data.weekWindow ?? null;
          state.error = null;
        },
      )
      .addCase(fetchParentTimetable.rejected, (state, action) => {
        state.loading = false;
        state.timetable = [];
        state.weekWindow = null;
        state.error = action.payload?.message || 'Failed to fetch the timetable.';
      });
  },
});

export const { resetParentTimetableState } = parentTimetableSlice.actions;
export default parentTimetableSlice.reducer;
